var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.964 1.037a3.529 3.529 0 00-4.995 0L.812 10.191a.458.458 0 00-.13.262L.005 15.48c-.02.143.031.286.13.385A.466.466 0 00.458 16c.02 0 .04 0 .061-.003l3.028-.41a.46.46 0 10-.123-.913L.997 15l.473-3.504 3.689 3.688a.452.452 0 00.648 0l9.157-9.153A3.51 3.51 0 0016 3.532c0-.943-.368-1.83-1.036-2.495zm-4.817 1.125L11.684 3.7l-8.356 8.356-1.537-1.538 8.356-8.356zM5.487 14.21l-1.504-1.503 8.356-8.356 1.503 1.504-8.356 8.355zm8.996-9.013l-3.678-3.679a2.604 2.604 0 011.663-.596 2.605 2.605 0 012.611 2.61c0 .618-.21 1.198-.596 1.665z",
    fill: "#9F9F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/edit.6952ccb51425dfef423132ed12eb1023.svg";
export { SvgEdit as ReactComponent };